<template>
  <SignInParticipation v-if="activity" :activity-id="activity.id" compact @detail="openPromotion(activity)" @claimed="loadMember" />
  <p v-else-if="error" class="member-sign-error">{{ error }} <button type="button" @click="load">重试</button></p>
</template>
<script setup>
import { ref, watch, onBeforeUnmount } from 'vue';
import SignInParticipation from './SignInParticipation.vue';
import { webApi } from '../services/webApi';
import { authStorage } from '../services/http';
import { useAppContext } from '../composables/appContext';
const { isLoggedIn, openPromotion, loadMember } = useAppContext();
const activity = ref(null), error = ref('');
let sequence = 0;
async function load() {
  const current = ++sequence, token = authStorage.getToken();
  activity.value = null; error.value = '';
  if (!isLoggedIn.value || !token) return;
  try {
    const items = await webApi.activities();
    if (current !== sequence || token !== authStorage.getToken()) return;
    if (!Array.isArray(items)) throw new Error('签到活动查询失败');
    activity.value = items.find(item => item.activityType === 'SIGN_IN' && Number(item.status) === 1) || null;
  } catch (cause) { if (current === sequence && token === authStorage.getToken()) error.value = cause.message || '签到活动查询失败'; }
}
watch(isLoggedIn, load, { immediate: true });
onBeforeUnmount(() => { sequence++; });
</script>
<style scoped>
.member-sign-error { margin-top: 24px; color: #b54c4c; }
.member-sign-error button { background: transparent; color: #3085b6; }
</style>
